module.exports = __webpack_public_path__ + "img/Path 15 Copy@3x.70a04fe4.png";